const EMBEDDED_WORKFLOW_BUILDER_PATH =
  /^\/workspaces\/[^/]+\/journeys\/(campaigns|automations)\/\d+\/(setup|overview)\/workflow(\/|$)/i;

/**
 * True for the embedded app's automation workflow builder, which reloads an agent's edits to the
 * open automation from realtime. Hydra's own canvas (`/workspaces/:id/automations/:id/workflow`)
 * does not match: it refreshes from its own queries.
 */
export const isEmbeddedWorkflowBuilderPath = (pathname: string) => EMBEDDED_WORKFLOW_BUILDER_PATH.test(pathname);
